export const ACTION_COLOR =
  'var(--ricos-settings-action-color, var(--ricos-action-color-fallback, #116dff))';

export const BG_COLOR = 'var(--ricos-settings-bg-color-background-color, rgba(0,0,0,.2))';

export const ACTION_COLOR_LIVESITE =
  'var(--ricos-native-text-color,  var(--ricos-action-color, #116dff))';

export const BG_COLOR_LIVESITE =
  'var(--ricos-native-secondary-bg-color-background-color, rgba(var(--ricos-text-color-low-tuple, 150, 150, 150),.2) )';

export const SLIDER_THUMB_VISIBILITY = { hover: 'hover', fixed: 'fixed' };

export const SLIDER_TRACK_SIZE = { small: 'small_track', medium: 'medium_track' };

export const KEYS_CHARCODE = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
};

export const BUTTON_SIZE = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
};
